import React from 'react';
import { Link } from 'react-router-dom';

export function ProjectSelector({ projects, currentProjectId, onSelectProject }) {
  const [isOpen, setIsOpen] = React.useState(false);
 
  const projectList = Array.isArray(projects) ? projects : [];
  const normalizedCurrentId = currentProjectId == null ? '' : String(currentProjectId);
  const currentProject = projectList.find(p => String(p?.id ?? '') === normalizedCurrentId);
  
  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          background: '#1f2937',
          color: '#e5e7eb',
          border: '1px solid #374151',
          borderRadius: 8,
          padding: '8px 12px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          minWidth: 200
        }}
      >
        <span>{currentProject?.name || 'Select Project'}</span>
        <span style={{ marginLeft: 'auto' }}>▼</span>
      </button>
      
      {isOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: '#111827',
          border: '1px solid #374151',
          borderRadius: 8,
          marginTop: 4,
          maxHeight: 300,
          overflowY: 'auto',
          zIndex: 1000
        }}>
          {projectList.map(project => (
            <Link
              key={project.id}
              to={`/projects/${project.id}`}
              onClick={() => {
                setIsOpen(false);
                onSelectProject?.(project.id);
              }}
              style={{
                display: 'block',
                padding: '8px 12px',
                color: '#e5e7eb',
                textDecoration: 'none',
                borderBottom: '1px solid #1f2937',
                background: String(project.id) === normalizedCurrentId ? '#374151' : 'transparent',
                ':hover': { background: '#374151' }
              }}
            >
              {project.name}
            </Link>
          ))}
          <Link
            to="/projects"
            style={{
              display: 'block',
              padding: '8px 12px',
              color: '#ff7a45',
              textDecoration: 'none',
              textAlign: 'center'
            }}
          >
            + Create New Project
          </Link>
        </div>
      )}
    </div>
  );
 }
